// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotificationItem {
  border-bottom: 1px solid rgba(204, 204, 204, 0.493);
  padding: 5px 10px;
  display: flex;
  align-items: center;
  background-color: #fff;
  cursor: pointer;
  transition: 200ms;
  text-decoration: none;
  color: var(--fontColor);
}
.NotificationItem .content {
  margin-left: 10px;
}
.NotificationItem .content p {
  margin: 0;
  padding: 0;
  font-weight: bold;
  font-size: 15px;
  margin-top: 5px;
}
.NotificationItem .content span {
  font-size: 13px;
  color: #ccc;
  display: block;
  margin-bottom: 5px;
}

.dark .NotificationItem {
  background-color: var(--darkSecondColor);
  border-bottom: 1px solid rgba(204, 204, 204, 0.1);
  color: var(--darkFont);
}
.dark .NotificationItem:hover {
  background-color: rgba(122, 122, 253, 0.2039215686);
}

.NotificationItem:hover {
  background-color: rgb(245, 245, 245);
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Navbar/Notifications/NotificationItem/notificationItem.scss"],"names":[],"mappings":"AAAA;EACE,mDAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;AACF;AAAE;EACE,iBAAA;AAEJ;AADI;EACE,SAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AAGN;AADI;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AAGN;;AAEE;EACE,wCAAA;EACA,iDAAA;EACA,sBAAA;AACJ;AACE;EACE,mDAAA;AACJ;;AAEA;EACE,oCAAA;AACF","sourcesContent":[".NotificationItem {\n  border-bottom: 1px solid rgba(204, 204, 204, 0.493);\n  padding: 5px 10px;\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  cursor: pointer;\n  transition: 200ms;\n  text-decoration: none;\n  color: var(--fontColor);\n  .content {\n    margin-left: 10px;\n    p {\n      margin: 0;\n      padding: 0;\n      font-weight: bold;\n      font-size: 15px;\n      margin-top: 5px;\n    }\n    span {\n      font-size: 13px;\n      color: #ccc;\n      display: block;\n      margin-bottom: 5px;\n    }\n  }\n}\n.dark {\n  .NotificationItem {\n    background-color: var(--darkSecondColor);\n    border-bottom: 1px solid rgba(204, 204, 204, 0.1);\n    color: var(--darkFont);\n  }\n  .NotificationItem:hover {\n    background-color: #7a7afd34;\n  }\n}\n.NotificationItem:hover {\n  background-color: rgb(245, 245, 245);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
